import { Avatar, Box, Button, Heading, HStack, Input, Stack, Text, VStack } from '@chakra-ui/react'
import React, { useRef, useState } from 'react'
import axios from "axios";
import { youtube_parser } from './util';

const Main = () => {
  const inpurl = useRef();
  const [urlref,setUrlref]=useState(null)
  const handleSubimte=(e)=>{
    e.preventDefault()
    console.log(inpurl.current.value);
const youtubeID = youtube_parser(inpurl.current.value)
console.log(youtubeID);
  
    const options = {
      method: 'GET',
      url: 'https://youtube-mp36.p.rapidapi.com/dl',
      params: {id: youtubeID},
      headers: {
        'X-RapidAPI-Key': '5be64c4d8emshb2907deb20c01e5p193e12jsn4b8679495c16',
        'X-RapidAPI-Host': 'youtube-mp36.p.rapidapi.com'
      }
    };
    
    axios.request(options).then(function (response) {
      console.log(response.data.link);
      setUrlref (response.data.link);
    }).catch(function (error) {
      console.error(error);
    });
inpurl.current.value = '';

  }
  return (<>
    <span className='logo'>MJ Mp3 Downloader</span>
    <div className='main'>

      
      <Heading color={'white'}>MP3 Downloader</Heading>
      <section>
        <form onSubmit={handleSubimte} className='form'>
          <Input textAlign={'center'} ref={inpurl} w={'30%'} p={'8'} borderRadius={'5'} border={'solid 1px'} placeholder='paste the youtube link....'/>
         <br />  <Button cursor={'pointer'} p={'8'} m={'5'} w={'25%'} borderRadius={'5'} border={'solid 1px '} variant={'ghost'} background={'black'} color={'white'} fontSize={'1rem'} type={'submit'}> Search</Button>
        </form>
        {urlref ?<a href={urlref} target="_blank" rel="noopener noreferrer">click here to download</a>:''}
      </section>
     
    </div>
    <footer>
    <Box background={'blackAlpha.900'} color={'whiteAlpha.700'} py={['16','8']} px={'16'} minH={'48'} >
<Stack  
direction={['column','row']}
h={'full'}
alignItems={'center'}
>
<VStack w={'full'} alignItems={['center','flex-start']} >
<Text fontWeight={'bold'}>About US</Text>
<Text fontFamily={'cursive'}>Founder : MOHIT VERMA</Text>
<Text fontSize={'sm'} letterSpacing={'widest'} textAlign={['center','left']} >Email: vermaji123089@gmail.com</Text>

    {/* <Avatar boxSize={'28'} mt={['4','0']} src={'https://pps.whatsapp.net/v/t61.24694-24/315769892_700770638147268_330371032929238813_n.jpg?ccb=11-4&oh=01_AdTFdFZuKkMhepedrcsNXg8xnuABmxg3E0vffuXP6ta0UQ&oe=63D87F2A'}/> */}
    <Text fontSize={'sm'} letterSpacing={'widest'} textAlign={['center','left']} >Our Founder</Text>

    <Box><h3> &copy; 2023 to 2024 all  right reserver by <span background={'red'}>♥</span>MOHIT VERMA </h3></Box>

<Avatar boxSize={'28'} mt={['4','0']} src={'https://pps.whatsapp.net/v/t61.24694-24/315769892_700770638147268_330371032929238813_n.jpg?ccb=11-4&oh=01_AdTFdFZuKkMhepedrcsNXg8xnuABmxg3E0vffuXP6ta0UQ&oe=63D87F2A'}/>
</VStack>
</Stack>
   </Box>
    </footer>
    </>

  )
}

export default Main